import React, { useState } from "react";
import { motion } from "framer-motion";
import { TracksPoweredBy } from "../common";
import { DownloadIcon, MenuIcon } from "../icons";
import { useRadioPlayerContext } from "../../providers/RadioPlayerContext";

const Footer = ({ setIsOpen }) => {
  const { currentTrack } = useRadioPlayerContext();

  const [downloadProgress, setDownloadProgress] = useState(null); // null یا درصد عددی

  // const downloadCurrentTrack = async () => {
  //   if (!currentTrack) return;
  //   try {
  //     const response = await fetch(currentTrack.src);
  //     if (!response.ok) throw new Error("Download failed");

  //     const contentLength = response.headers.get("Content-Length");
  //     if (!contentLength) throw new Error("No content length");

  //     const total = parseInt(contentLength, 10);
  //     let loaded = 0;
  //     const reader = response.body.getReader();
  //     const chunks = [];

  //     setDownloadProgress(0);

  //     while (true) {
  //       const { done, value } = await reader.read();
  //       if (done) break;
  //       chunks.push(value);
  //       loaded += value.length;
  //       const percent = Math.floor((loaded / total) * 100);
  //       setDownloadProgress(percent);
  //     }

  //     const blob = new Blob(chunks, { type: "audio/mpeg" });
  //     const url = URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = `${currentTrack.title}.mp3`;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     URL.revokeObjectURL(url);

  //     setDownloadProgress(null);
  //   } catch (e) {
  //     console.error("Download failed", e);
  //     setDownloadProgress(null);
  //   }
  // };

  const downloadCurrentTrack = () => {
    if (!currentTrack) return;

    const link = document.createElement("a");
    link.href = currentTrack.src;
    link.setAttribute("download", `${currentTrack.title}.mp3`);
    link.setAttribute("rel", "noopener noreferrer");
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex flex-col gap-4 z-[10]">
      <TracksPoweredBy />

      <button
        // disabled={downloadProgress}
        onClick={downloadCurrentTrack}
        className="flex items-center justify-center gap-2 border border-gray-300 rounded-lg text-sm xxxs:text-base p-3 xxxs:p-4"
      >
        <DownloadIcon className="size-6" />
        <span>{`دانلود آهنگ ${currentTrack?.title}`}</span>
      </button>

      {/* <motion.button
        onClick={downloadCurrentTrack}
        className="relative overflow-hidden flex items-center justify-center gap-2 border border-gray-300 rounded-lg text-sm xxxs:text-base p-3 xxxs:p-4"
        disabled={downloadProgress !== null}
      >
        <motion.div
          className="absolute left-0 top-0 h-full bg-[#3b3c46] z-0"
          initial={{ width: "0%" }}
          animate={{ width: downloadProgress !== null ? `${downloadProgress}%` : "0%" }}
          transition={{ ease: "easeInOut", duration: 0.2 }}
        />

        <div className="flex items-center gap-2 z-10 text-white">
          <DownloadIcon className="size-6" />
          <motion.span
            key={downloadProgress !== null ? "progress" : "text"}
            initial={{ opacity: 0, y: 5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.3 }}
          >
            {downloadProgress !== null
              ? `${downloadProgress}%`
              : `دانلود آهنگ ${currentTrack?.title}`}
          </motion.span>
        </div>
      </motion.button> */}

      <button
        onClick={() => setIsOpen(true)}
        className="flex items-center justify-center gap-2 border border-gray-300 rounded-lg text-sm xxxs:text-base p-3 xxxs:p-4"
      >
        <MenuIcon className="size-4" />
        <span>کانال های رادیو</span>
      </button>
    </div>
  );
};

export default Footer;
